// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.milestone-card {
  border: 2px solid #c3c5f8;
  border-radius: 25px;
  margin-bottom: 50px;
  height: auto;
  padding-bottom: 15px;
}
.milestone-card img {
  border-radius: 25px;
  height: 180px;
  width: 100%;
  object-fit: cover;
}
.milestone-card h2 {
  font-size: var(--f20);
  color: var(--dBlue);
  margin-top: 20px;
  height: 95px;
}

.milestone-card .read-more-less-btn {
  color: var(--dPink);
}

.milestone-date {
  font-size: var(--pSize);
  color: #9d9d9d;
  font-weight: 500;
}
.milestone-paragraph {
  font-size: var(--pSize);
  color: #323232;
  font-weight: 400;
  height: auto;
}
.milestone-paragraph,
.milestone-date,
.milestone-card h2 {
  padding: 0px 25px;
}

.rm-rl-wrapper {
  padding: 0 25px;
}

.read-more-less-btn {
  background: none;
  border: medium none currentColor;
  border: initial;
  color: var(--dBlue);
}

@media (max-width: 576px) {
  .milestone-card img {
    height: 130px;
  }

  .milestone-card {
    height: auto;
  }

  .milestone-paragraph,
  .milestone-date,
  .milestone-card h2 {
    padding: 0 15px;
  }

  .milestone-card h2,
  .milestone-paragraph {
    height: auto;
  }
}

@media only screen and (min-width: 1080px) and (max-width: 1200px) {
  .milestone-card {
    height: 580px;
  }

  .milestone-card h2 {
    height: 160px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/about/MilestoneCard.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;AACA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gCAAa;EAAb,eAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;;IAEE,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".milestone-card {\n  border: 2px solid #c3c5f8;\n  border-radius: 25px;\n  margin-bottom: 50px;\n  height: auto;\n  padding-bottom: 15px;\n}\n.milestone-card img {\n  border-radius: 25px;\n  height: 180px;\n  width: 100%;\n  object-fit: cover;\n}\n.milestone-card h2 {\n  font-size: var(--f20);\n  color: var(--dBlue);\n  margin-top: 20px;\n  height: 95px;\n}\n\n.milestone-card .read-more-less-btn {\n  color: var(--dPink);\n}\n\n.milestone-date {\n  font-size: var(--pSize);\n  color: #9d9d9d;\n  font-weight: 500;\n}\n.milestone-paragraph {\n  font-size: var(--pSize);\n  color: #323232;\n  font-weight: 400;\n  height: auto;\n}\n.milestone-paragraph,\n.milestone-date,\n.milestone-card h2 {\n  padding: 0px 25px;\n}\n\n.rm-rl-wrapper {\n  padding: 0 25px;\n}\n\n.read-more-less-btn {\n  background: none;\n  border: unset;\n  color: var(--dBlue);\n}\n\n@media (max-width: 576px) {\n  .milestone-card img {\n    height: 130px;\n  }\n\n  .milestone-card {\n    height: auto;\n  }\n\n  .milestone-paragraph,\n  .milestone-date,\n  .milestone-card h2 {\n    padding: 0 15px;\n  }\n\n  .milestone-card h2,\n  .milestone-paragraph {\n    height: auto;\n  }\n}\n\n@media only screen and (min-width: 1080px) and (max-width: 1200px) {\n  .milestone-card {\n    height: 580px;\n  }\n\n  .milestone-card h2 {\n    height: 160px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
